const config = {
  server_base_url: process.env.NODE_ENV=='development' ? "http://localhost:5001" : "https://seva.mooji.org",
};

module.exports = config;